import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { DropdownContent } from './DropdownContent';
import { MenuItems } from './MenuItems';
import { WarningAndErrors } from './WarningAndErrors';
import { LinkField } from '../../LinkField';
export function RemainderDropdown() {
    const [dueDateField, , dueDateHelpers] = useField('reminder.dueDate');
    const [, , intervalHelpers] = useField('reminder.interval');
    const [open, setOpen] = useState(false);
    const formatted = localizedFormatDate(dueDateField.value, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
    const handleRemoveReminder = () => {
        dueDateHelpers.setValue('');
        intervalHelpers.setValue(undefined);
    };
    const toggleMenu = () => setOpen(!open);
    const closeMenu = () => setOpen(false);
    const target = (<Box flexDirection="column" gap="sm">
      <LinkField name="reminder.dueDate" icon={<Falcon icon="alarm-clock"/>} onRemove={handleRemoveReminder} onClick={toggleMenu} linkPrefix={t({
            message: 'Reminder will be sent on',
            comment: 'Task reminder field link text when reminder is set',
        })} linkText={formatted ||
            t({
                message: 'Add reminder',
                comment: 'Task Reminder field link text when no reminder is set',
            })}/>
      <WarningAndErrors />
    </Box>);
    return (<Menu.Root open={open} onClose={closeMenu} target={target}>
      <DropdownContent />
      <MenuItems />
    </Menu.Root>);
}
